// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__32mbb","inputWrap":"CustomTip_inputWrap__2PcJf"};